/**
 * Strikethrough for "done" entities (closed tickets, completed workorders).
 * A 30% foreground line reads fine on light backgrounds but nearly vanishes on
 * dark ones, so dark mode gets a stronger line.
 */
export const LINE_THROUGH_CLASSES =
  'line-through decoration-1 decoration-foreground/30 dark:decoration-foreground/60';
